import { Stack, Typography } from "@mui/material";
import { SavingReport } from "Components/Merchant/FeeCalculator/YearlySavingsWidget/SavingReport";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import { Resources, useResource } from "Translations/Resources";

type Props = {
  currentCosts: number;
  legioneCosts: number;
  mooneCosts: number;
};

export const YearlySavingsWidget = ({
  currentCosts,
  legioneCosts,
  mooneCosts,
}: Props) => {
  const { t } = useResource();

  const legioneSavings = currentCosts - legioneCosts;
  const mooneSavings = currentCosts - mooneCosts;

  const legioneSavingsPercentage = currentCosts
    ? (legioneSavings / currentCosts) * 100
    : 0;
  const mooneSavingsPercentage = currentCosts
    ? (mooneSavings / currentCosts) * 100
    : 0;

  return (
    <PrimaryPaper sx={{ width: "100%", height: "100%" }}>
      <Stack gap={2}>
        <Typography variant="h6">
          {t(
            Resources.Pages.Content.MerchantFeeCalculator.YearlySavingsWidget
              .PotentialYearlySavings,
          )}
        </Typography>
        <SavingReport
          label={t(
            Resources.Pages.Content.MerchantFeeCalculator.YearlySavingsWidget
              .WithLegione,
          )}
          amount={legioneSavings}
          percentage={legioneSavingsPercentage}
        />
        <SavingReport
          label={t(
            Resources.Pages.Content.MerchantFeeCalculator.YearlySavingsWidget
              .WithMoone,
          )}
          amount={mooneSavings}
          percentage={mooneSavingsPercentage}
        />
      </Stack>
    </PrimaryPaper>
  );
};
